let GenericKeys = {
    requestIds: 'RequestIds',
    correlationVectors: 'cV', // this needs to be cV so we can correlate with other databases
    cache: 'Cache',
    e2eTimeElapsed: 'E2ETimeElapsed',
};

export { GenericKeys };
